<template>
  <app-layout>
    
    <h1>Hey {{ currentUser.name.split(" ")[0] }}</h1>

    <div class='clearfix'></div>
    
    <p class="gray mt-2">App-Version: <b>{{ appVersion }}</b></p>

    <router-link to="workout" v-if="activeWorkout" class="box mw" v-ripple>
      <img :src="activeWorkout.plan.image_url" class="responsive" />
    </router-link>
    
    <router-link to="workouts" class="box mw" v-else v-ripple>
      <div class="imgBox default">
        <img src="../assets/images/blank_bg.png" class="responsive" />
      </div>
      <hr class="half-press"/>
      all Workouts
    </router-link>

    <br>

    <table class="facts ">
      <tr>
        <th class="rgt">Name:</th>
        <td class="lft">{{ currentUser.name }}</td>
      </tr>
      <tr>
        <th class="rgt">Level:</th>
        <td class="lft">{{ currentUser.level }}</td>
      </tr>
      <tr>
        <th>Day ends:</th>
        <td>{{ currentUser.day_ends_at }}</td>
      </tr>
    </table>

    <br>

    <v-alert :value="!!checkText" outline color="amber" class="loud bold mx-5">
      {{ checkText }}
    </v-alert>
    <v-btn color="amber" outline round @click="checkAuth" v-if="!checkText">
      <i class="icon-power" />
      &nbsp;
      Check Auth
      &nbsp;
      <i class="icon-power" />
    </v-btn>

    <bottom-nav />

  </app-layout>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';
import FullBox from '@/components/ui/FullBox.vue';
import BottomNav from '@/components/layout/BottomNav';
import { mapGetters } from 'vuex';
import SportBG from '@/assets/images/sports.png';
import axios    from '@/services/axios';

export default {
  name: 'home',
  components: {
    HelloWorld,
    FullBox,
    BottomNav
  },
  data() {
    return {
      checkText: ""
    }
  },
  computed: {
    ...mapGetters(["currentUser", "activeWorkout"]),
    appVersion() {
      console.log("appVersion", process.env, require('./../../package.json').version )
      return require('./../../package.json').version
    }
  },
  methods: {
    checkAuth() {
      console.log("checkAuth")
      axios.get("/check").then((response) => {
        console.log("checkAuth - Success: ", response)
        this.checkText = "All good, you are logged in!"
      }).catch((error) => {
        console.log("checkAuth - ERROR!: ", error)
        this.checkText = "Oh no! .. You are logged out!"
      });
    }
  }
};
</script>

<style lang="scss">
#home {
  // background: transparent url('../assets/images/sports_blur.png') left top repeat;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANklEQVQoU2NkwAPu3r37nxGXPEhSWVmZEasCmCRIM4YCZEkMBeiSKAqwScIV4JIEK8AnCVIAABoiH59e1lDMAAAAAElFTkSuQmCC) #fbfbfb;
}

.imgBox, .picBox {
  &.default {
    background-image: url("../assets/images/sports.png");
    background-repeat: repeat;
  }
}
a.box.mw {
  width: 80%;
  max-width: 400px;
  margin: 0 auto 20px;
}

</style>
